// The auto scheduler reads only the clock of reg_time, never its date, so the
// master's local clock is encoded as the instant that shows it.

export function regTimeToUnix(time: string | null | undefined): number | null {
  if (!time) {
    return null;
  }

  const [hour, minute] = time.split(":");
  const instant = new Date();
  instant.setHours(parseInt(hour, 10), parseInt(minute, 10), 0, 0);

  return Math.floor(instant.getTime() / 1000);
}

export function unixToRegTime(unix: number | null | undefined): string | null {
  if (unix == null) {
    return null;
  }

  const instant = new Date(unix * 1000);

  return (
    instant.getHours().toString().padStart(2, "0") +
    ":" +
    instant.getMinutes().toString().padStart(2, "0")
  );
}

export function writtenFilterRegTime(time: string | null | undefined): {
  reg_time: number | null;
  use_reg_time: true;
} {
  return {
    reg_time: regTimeToUnix(time),
    use_reg_time: true,
  };
}
